import { ExternalQuestionDetail } from '@pages/project-management/project-questionaire/components/external-questions';

const ExternalQuestionDetailPage = () => {
  return <ExternalQuestionDetail />;
};

export default ExternalQuestionDetailPage;
